import { DirectiveOptions, DirectiveFunction } from 'vue/types/umd';
import { DirectiveBinding } from 'vue/types/options';
import { theme } from "../../../tailwind.config.js";

const moveAnimationCenterBottomLeft = [
    {
        transform: 'translate(50vw, -50vh)',
        opacity: 0.7,
    }, {
        transform: 'translate(0px, 0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const moveAnimationCenterBottomRight = [
    {
        transform: 'translate(-50vw, -50vh)',
        opacity: 0.7,
    }, {
        transform: 'translate(0px, 0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]
const moveAnimationCenterTopLeft = [
    {
        transform: 'translate(50vw, 50vh)',
        opacity: 0.7,
    }, {
        transform: 'translate(0px, 0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const moveAnimationCenterTopRight = [
    {
        transform: 'translate(-50vw, 50vh)',
        opacity: 0.7,
    }, {
        transform: 'translate(0px, 0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const moveAnimationCenterTop = [
    {
        transform: 'translateY(50vh)',
        opacity: 0.7,
    }, {
        transform: 'translateY(0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const moveAnimationCenterBottom = [
    {
        transform: 'translateY(-50vh)',
        opacity: 0.7,
    }, {
        transform: 'translateY(0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]
const moveAnimationCenterLeft = [
    {
        transform: 'translateX(50vw)',
        opacity: 0.7,
    }, {
        transform: 'translateX(0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const moveAnimationCenterRight = [
    {
        transform: 'translateX(-50vw)',
        opacity: 0.7,
    }, {
        transform: 'translateX(0px)',
        opacity: 0.7,
    }, {
        opacity: 1
    }
]

const animation = [
    { // from
        opacity: 0,
    },
    { // to
        opacity: 0.5,
    }
];
const animationOption = { duration: 500, easing: "ease-in-out" }

const getAnimation = (position: HighlightPosition) => {
    if(!position){
        return;
    }
    if(position.top){
        if(position.left){
            return moveAnimationCenterTopLeft;
        }
        if(position.right){
            return moveAnimationCenterTopRight;
        }
        return moveAnimationCenterTop;
    }
    if(position.bottom){
        if(position.left){
            return moveAnimationCenterBottomLeft;
        }
        if(position.right){
            return moveAnimationCenterBottomRight;
        }
        return moveAnimationCenterBottom;
    }
    if(position.left){
        return moveAnimationCenterLeft;
    }
    if(position.right){
        return moveAnimationCenterRight;
    }
}

const removeHighlight = (el: any) => {
    if (!el.isHighlighted) {
        return;
    }
    el.isHighlighted = false;
    el.style.position = el.originalPosition;
    el.style.zIndex = el.originalZIndex;
    el.style.backgroundColor = el.originalBackgroundColor;
    el.style.color = el.originalColor;
    const hEl = document.getElementById(el.highlightId);
    if (hEl) {
        hEl.animate(animation, { ...animationOption, direction: "reverse" });
        window.setTimeout(() => el.parentNode.removeChild(hEl), 400);
    }
}

const doHighlight = (el: any, position: HighlightPosition, duration: number) => {
    if (el.isHighlighted) {
        removeHighlight(el);
        return;
    }
    el.originalPosition = el.style.position;
    el.style.position = "relative";
    el.originalZIndex = el.style.zIndex;
    el.style.zIndex = "100";
    el.originalBackgroundColor = el.style.backgroundColor;
    el.style.setProperty("background-color", theme.extend.colors['brand-yellow']['600'], "important");
    el.originalColor = el.style.color;
    el.style.setProperty("color", "var(--color-text-opposite)", "important");
    el.animate(getAnimation(position), {duration: duration})
    const glass = document.createElement('div');
    glass.style.cssText = 'position: fixed; top: 0; right: 0; bottom: 0; left: 0; background-color: #000; opacity: 0.5; z-index: 90;';
    glass.animate(animation, animationOption)
    el.highlightId = el.id + "-highlight-id-" + Math.random();
    glass.id = el.highlightId
    el.parentNode.appendChild(glass);
    el.isHighlighted = true;
}

const computeArgs = (bindings: DirectiveBinding) => {
    if(!bindings.value){
        return {
            value: false
        }
    }
    if(typeof(bindings.value) === "boolean"){
        return {
            value: bindings.value,
            position: bindings.modifiers,
            duration: bindings.arg ? parseInt(bindings.arg) : 1000
        }       
    }
    return {
        value: bindings.value.value,
        position: bindings.value.position,
        duration: bindings.value.duration || 1000
    }
}

export const Highlight: { [key: string]: DirectiveFunction | DirectiveOptions } = {
    inserted(el, bindings) {
        const {value, position, duration} = computeArgs(bindings);
        if (value) {
            doHighlight(el, position, duration)
        } else {
            removeHighlight(el)
        }
    },
    componentUpdated(el, bindings) {
        const {value, position, duration} = computeArgs(bindings);
        if (value) {
            doHighlight(el , position, duration)
        } else {
            removeHighlight(el)
        }
    },
    unbind(el) {
        removeHighlight(el)
    }
}

export interface HighlightOption {
    position: HighlightPosition;
    duration?: number;
    value: boolean;
} 

export interface HighlightPosition {
    top?: boolean;
    bottom?: boolean;
    left?: boolean;
    right?: boolean;
}